import type { DealFormDataWithTargeting } from '@openx/types/deal';
import { ensureDateStartOfMinute, toUTCDateTime, toUTCString } from '@openx/utils/lib/date';
import cloneDeep from 'lodash/cloneDeep';

export const parseDealDate = ensureDateStartOfMinute;

export const fixDealStartAndEndDateFormat = (
  deal: DealFormDataWithTargeting
): DealFormDataWithTargeting<string | null> => {
  const fixedStartDate = toUTCString(toUTCDateTime(deal.start_date));
  const fixedEndDate = toUTCString(toUTCDateTime(deal.end_date));

  const outputDeal: DealFormDataWithTargeting<string | null | Date> = cloneDeep(deal);
  if (fixedStartDate) {
    outputDeal.start_date = fixedStartDate;
  }

  if (fixedEndDate) {
    outputDeal.end_date = fixedEndDate;
  }

  return outputDeal as DealFormDataWithTargeting<string | null>;
};
